import Axios from "../config/config";

//Announcement

export const ANNOUNCEMENT_LIST= async (body) => {
    try {
        const response = await Axios.post('news-list/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const ANNOUNCEMENT_STATUS= async (body) => {
    try {
        const response = await Axios.post('news-status/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const DELETE_ANNOUNCEMENT= async (body) => {
    try {
        const response = await Axios.post('delete-news/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};



export const ADD_ANNOUNCEMENT= async (body) => {
    try {
        const response = await Axios.post('add-news/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const VIEW_ANNOUNCEMENT= async (body) => {
    try {
        const response = await Axios.post('view-news/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const EDIT_ANNOUNCEMENT= async (body) => {
    try {
        const response = await Axios.post('edit-news/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};